// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Conclusion_buttons__3gbJK","center":"Conclusion_center__3w8N0","green":"Conclusion_green__38nch"};